import React from 'react';

import SortIcon from 'assets/images/icon/SortIcon';
import styled from 'styled-components';
import { CheckBox } from 'view/components/common/CheckBox';

interface StyledComponentProps {
    width?: string;
}

const PurchaseTitle = (props) => {

    return (
        <Container>

            <Col width={"130px"}>
                <span>Name</span>
                <SortIcon/>
            </Col>
            <Col width={"102px"} >
                <span>Type</span>
                <SortIcon/>
            </Col>
            <Col width={"130px"} style={{}}>
                <span>Title</span>
                <SortIcon/>
            </Col>
            <Col width={"130px"}>
                <span>Purchase Date</span>
                <SortIcon/>
            </Col>
            <Col width={"100px"}>
                <span>Refund</span>
                <SortIcon/>
            </Col>
            <Col width={"100px"}>
                <span>Action</span>
                <SortIcon/>
            </Col>
        </Container>
    );
};
export default PurchaseTitle;

const Container = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding: 18px 20px;
    border-bottom: solid 1px #e9edf5;

    &::-webkit-scrollbar {
        width: 1px;
        height: 2px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`;

const Col = styled.div<StyledComponentProps>`
    display: flex;
    align-items: center;
    width: ${(props) => (props.width ? `${props.width}` : "auto")};
    min-width: ${(props) => (props.width ? `${props.width}` : "auto")};
    flex-wrap: wrap;
    /* min-width: ${(props) => (props.width ? `calc(${props.width} / 100%)` : "auto")}; */
    margin: 0 10px;
    justify-content: flex-start;
    &:nth-child(1) {
        margin-left: 0;
        margin-right: 0.5%;
    }
    &:last-child{
        margin-right:0;
    }
    span {
        padding-top: 1px;
        font-size: 14px;
        font-weight: 700;
        color: #333333d5;
    }
`;

const Icons = styled.div`
    display: flex;
    align-items: center;
`;
const Icon = styled.div`
    display: flex;
    align-items: center;
`;
